// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"278":"d5c282d7","702":"b8511c48"}[chunkId] + ".chunk.css";
};